import { Icon } from "@blueprintjs/core";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { PlanrPopover } from "modules/common/components/planr/popover/Popover";
import React, { useState } from "react";
import { OrderLogsStoreType } from "../models/order-logs";
import popover from "./HeaderPopover.module.scss";
import { LogList } from "./LogList";

interface HistoryButtonProps {
    store: OrderLogsStoreType;
    orderId: string;
    /** вид кнопки задаёт шапка — столбец мелких кнопок */
    className: string;
    iconClassName: string;
}

/**
 * «История» в шапке карточки договора: журнал изменений во всплывающем окне под кнопкой, как список ошибок.
 * Журнал монтируется при открытии и каждый раз перечитывается; пока он грузится, индикатор — внутри окна
 */
export const HistoryButton = ({ store, orderId, className, iconClassName }: HistoryButtonProps) => {
    const [open, setOpen] = useState(false);

    return (
        <PlanrPopover
            isOpen={open}
            onInteraction={setOpen}
            placement="bottom-start"
            usePortal={true}
            content={
                <div className={`${popover.popover} ${popover.wide}`}>
                    <div className={popover.popoverHeader}>
                        <span className={popover.popoverTitle}>История изменений</span>
                    </div>
                    <div className={popover.popoverBody}>
                        {open && <LogList store={store} orderId={orderId} className={popover.historyList} />}
                    </div>
                </div>
            }
        >
            <PlanrButton type="graybtn" size="small" className={className}>
                <Icon icon="history" size={12} className={iconClassName} />
                История
            </PlanrButton>
        </PlanrPopover>
    );
};
